module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-right-square-fill-475f18cf.svg";